export default "__VITE_ASSET__9Fwi6jgc__"